import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { PersonType } from 'src/app/services/models/enums';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogProps,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NO_NAME } from '../../constants';
import {
  RestrictiveData,
  TrackingRegistryView,
} from 'src/app/views/list-individual/services/list-individual.facade';

type IDocumentIndicatosDialogProps = TrackingRegistryView;

@Component({
  selector: 'app-document-indicators-modal',
  templateUrl: './document-indicators-modal.component.html',
  styleUrls: ['./document-indicators-modal.component.scss'],
  imports: [CommonModule, SharedModule, MatDialogModule, ConfirmationDialogComponent],
})
export class DocumentIndicatorsModalComponent implements OnDestroy {
  name: string;
  document: string;
  restrictives: RestrictiveData[] = [];
  personType = PersonType.COMPANY;

  table = {
    titles: [
      {
        attribute: $localize`:@@attribute:Atributo`,
        quantity: $localize`:@@js_quantity:Cantidad`,
        totalValue: $localize`:@@js_totalValue:Valor total`,
        updateDate: $localize`:@@updateDate:Fecha de actualización Atributo`,
      },
    ],
  };

  private readonly subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly data: IDocumentIndicatosDialogProps,
    public dialogRef: MatDialogRef<DocumentIndicatorsModalComponent>,
    private readonly globalService: GlobalServiceService,
  ) {
    this.subscription = this.globalService.getPersonType$().subscribe((type) => {
      this.personType = type;
    });

    this.fillData();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleClose() {
    this.dialogRef.close();
  }

  fillData() {
    this.name = this.data.name || NO_NAME;
    this.document = this.data.document;
    this.restrictives = this.data.restrictives || [];
  }

  get confirmationDialogProps(): ConfirmationDialogProps {
    return {
      title: $localize`:@@restrictive:Restrictivo`,
      cancelButton: {
        hide: true,
      },
    };
  }
}
